import { GetCompanyEmailAddressesResponseType } from 'src/api/generated/touring/types';
import { CompanyEmailAddressesType } from './types';

export const mapGetCompanyEmailAddressesResponseType = (
  apiType: GetCompanyEmailAddressesResponseType
): CompanyEmailAddressesType => ({
  emails: apiType.data,
});
